import styles from './OurAdvantage.module.scss'

const OurAdvantage: React.VFC = () => {
  return (
    <>
      <section className={styles.section} id="OurAdvantage">
        <div className={styles.top}>
          <div className={styles.textWrapper}>
            <p className={`${styles.redText} ${styles.introText}`}>
              <span className={styles.redBox}></span>Our Advantage
            </p>
            <h3 className={styles.h3}>
              Aitriaだからできる
              <br />
              3つの強み
            </h3>
          </div>
        </div>
        <div className={styles.middle}>
          <div className={styles.rectImgWrapper}>
            <div className={styles.rectImg}></div>
          </div>
          <ul className={styles.ul}>
            <li className={styles.li}>
              <div className={`${styles.circleImg} ${styles.one}`}></div>
              <p className={`${styles.redText}`}>01 / Proposal</p>
              <h4 className={styles.h4}>
                ユーザー課題を明確化、
                <br />
                ニーズに合った戦略を提案
              </h4>
              <p className={styles.valueText}>
                ビジネスモデルの明確化とユーザー価値の再定義、ペルソナ定義とUXシナリオの作成、プロトタイピング、ユーザビリティ調査、リリース後の利用状況調査、システムの変更などプロジェクトに応じて柔軟に対応いたします。
              </p>
            </li>
            <li className={styles.li}>
              <div className={`${styles.circleImg} ${styles.two}`}></div>
              <p className={`${styles.redText}`}>02 / Improvement</p>
              <h4 className={styles.h4}>
                正しい情報設計とユーザビリティで
                <br />
                ユーザーの満足度を向上
              </h4>
              <p className={styles.valueText}>
                UIデザインのプロフェッショナルとして、デジタルプロダクトとしての情報設計におけるあるべき姿をご提案します。各プラットフォームの特性やユーザビリティ観点から、ご納得いただける説明を行います。
              </p>
            </li>
            <li className={styles.li}>
              <div className={`${styles.circleImg} ${styles.three}`}></div>
              <p className={`${styles.redText}`}>03 / Speedy</p>
              <h4 className={styles.h4}>
                立ち上げからリリースまで
                <br />
                社内完結だからできるスピード感
              </h4>
              <p className={styles.valueText}>
                プロジェクト計画 - UX/UIデザイン - 開発 -
                運用支援まで、それぞれのフェーズにおけるプロフェッショナルが在籍しているため、高いクオリティを担保し、スピード感を持ったプロジェクト進行が可能です。
              </p>
            </li>
          </ul>
        </div>
      </section>
    </>
  )
}

export default OurAdvantage
